export const BURGER_MENU_ID = 'BURGER_MENU_ID';
export const COUNTRY_SWITCHER_MENU_ID = 'COUNTRY_SWITCHER_MENU_ID';
export const PERSONAL_DATA_MENU_ID = 'PERSONAL_DATA_MENU_ID';
export const PRODUCT_INFORMATION_MENU_ID = 'PRODUCT_INFORMATION_MENU_ID';
export const PRODUCT_NOTIFY_ME = 'PRODUCT_NOTIFY_ME';
export const RATING_REVIEWS_FORM_ID = 'RATING_REVIEWS_FORM_ID';
export const RATING_REVIEWS_MENU_ID = 'RATING_REVIEWS_MENU_ID';
export const PRODUCT_PRICES_INFORMATION_MENU_ID = 'PRODUCT_PRICES_INFORMATION_MENU_ID';
export const PRODUCT_LEGAL_MENTIONS_DTS_MENU_ID = 'PRODUCT_LEGAL_MENTIONS_DTS_MENU_ID';
export const PRODUCT_INFO_QUICK_VIEW_MENU_ID = 'PRODUCT_INFO_QUICK_VIEW_MENU_ID';
export const PRODUCT_STORE_MENU_ID = 'PRODUCT_STORE_MENU_ID';
export const PRODUCT_DETAIL_VISUAL_MODAL_ID = 'PRODUCT_DETAIL_VISUAL_MODAL_ID';
export const WISHLIST_MODAL_ID = 'WISHLIST_MODAL_ID';
export const NEWSLETTER_MODAL_ID = 'NEWSLETTER_MODAL_ID';
export const ADDED_TO_BASKET_MODAL_ID = 'ADDED_TO_BASKET_MODAL_ID';
export const ENGRAVING_FORM_MODAL_ID = 'ENGRAVING_FORM_MODAL_ID';
